import React from "react";
import { FaLock, FaUniversity, FaWallet } from "react-icons/fa";
import {
  PhonePeLogo,
  GooglePayLogo,
  PaytmLogo,
  VisaLogo,
  MastercardLogo,
  RuPayLogo,
  CodLogo,
} from "./PaymentLogos";

const CheckoutPaymentMethods = ({
  paymentMethod = "",
  onSelectPaymentMethod,
  walletBalance = 0,
}) => {
  return (
    <div className="rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-base font-bold text-gray-900">Select Payment Method</h2>
        <div className="flex items-center gap-1 text-[11px] text-gray-500">
          <FaLock className="h-3 w-3 text-gray-400" />
          <span>All payments are secure & encrypted</span>
        </div>
      </div>

      <div className="space-y-3">
        {/* Option 1: UPI Payment (Recommended) */}
        <div
          onClick={() => onSelectPaymentMethod("UPI")}
          className={`cursor-pointer rounded-xl border p-4 transition-all ${
            paymentMethod === "UPI"
              ? "border-2 border-[#046a38] bg-emerald-50/20 shadow-sm"
              : "border-gray-200 bg-white hover:border-gray-300"
          }`}
        >
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
            <div className="flex items-start gap-3">
              <div
                className={`mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full border ${
                  paymentMethod === "UPI" ? "border-[#046a38]" : "border-gray-400"
                }`}
              >
                {paymentMethod === "UPI" && (
                  <div className="h-2 w-2 rounded-full bg-[#046a38]" />
                )}
              </div>
              <div>
                <div className="flex items-center gap-2">
                  <h3 className="text-sm font-bold text-gray-900">UPI Payment</h3>
                  <span className="rounded bg-emerald-100 px-1.5 py-0.5 text-[10px] font-bold text-[#046a38]">
                    Recommended
                  </span>
                </div>
                <p className="mt-0.5 text-xs text-gray-500">
                  Google Pay, PhonePe, Paytm & any UPI App
                </p>
              </div>
            </div>

            {/* UPI Actual Logos */}
            <div className="flex items-center gap-2 shrink-0 self-end sm:self-center">
              <PhonePeLogo />
              <GooglePayLogo />
              <PaytmLogo />
            </div>
          </div>
        </div>

        {/* Option 2: Credit / Debit Cards */}
        <div
          onClick={() => onSelectPaymentMethod("CARD")}
          className={`cursor-pointer rounded-xl border p-4 transition-all ${
            paymentMethod === "CARD"
              ? "border-2 border-[#046a38] bg-emerald-50/20 shadow-sm"
              : "border-gray-200 bg-white hover:border-gray-300"
          }`}
        >
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3">
            <div className="flex items-start gap-3">
              <div
                className={`mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full border ${
                  paymentMethod === "CARD" ? "border-[#046a38]" : "border-gray-400"
                }`}
              >
                {paymentMethod === "CARD" && (
                  <div className="h-2 w-2 rounded-full bg-[#046a38]" />
                )}
              </div>
              <div>
                <h3 className="text-sm font-bold text-gray-900">Credit / Debit Card</h3>
                <p className="mt-0.5 text-xs text-gray-500">
                  Visa, Mastercard, RuPay, Maestro
                </p>
              </div>
            </div>

            {/* Card & Gateway Logos */}
            <div className="flex items-center gap-2 shrink-0 self-end sm:self-center">
              <VisaLogo />
              <MastercardLogo />
              <RuPayLogo />
            </div>
          </div>
        </div>

        {/* Option 3: Net Banking */}
        <div
          onClick={() => onSelectPaymentMethod("NETBANKING")}
          className={`cursor-pointer rounded-xl border p-4 transition-all ${
            paymentMethod === "NETBANKING"
              ? "border-2 border-[#046a38] bg-emerald-50/20 shadow-sm"
              : "border-gray-200 bg-white hover:border-gray-300"
          }`}
        >
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-start gap-3">
              <div
                className={`mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full border ${
                  paymentMethod === "NETBANKING"
                    ? "border-[#046a38]"
                    : "border-gray-400"
                }`}
              >
                {paymentMethod === "NETBANKING" && (
                  <div className="h-2 w-2 rounded-full bg-[#046a38]" />
                )}
              </div>
              <div>
                <h3 className="text-sm font-bold text-gray-900">Net Banking</h3>
                <p className="mt-0.5 text-xs text-gray-500">
                  All Indian banks supported (SBI, HDFC, ICICI, Axis...)
                </p>
              </div>
            </div>

            <div className="flex h-7 items-center justify-center gap-1.5 rounded-md border border-gray-200 bg-gray-50 px-2.5 py-0.5 text-gray-700">
              <FaUniversity className="h-3.5 w-3.5 text-[#046a38]" />
              <span className="text-[11px] font-bold">NetBanking</span>
            </div>
          </div>
        </div>

        {/* Option 4: Cash on Delivery (COD) */}
        <div
          onClick={() => onSelectPaymentMethod("COD")}
          className={`cursor-pointer rounded-xl border p-4 transition-all ${
            paymentMethod === "COD"
              ? "border-2 border-[#046a38] bg-emerald-50/20 shadow-sm"
              : "border-gray-200 bg-white hover:border-gray-300"
          }`}
        >
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-start gap-3">
              <div
                className={`mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full border ${
                  paymentMethod === "COD" ? "border-[#046a38]" : "border-gray-400"
                }`}
              >
                {paymentMethod === "COD" && (
                  <div className="h-2 w-2 rounded-full bg-[#046a38]" />
                )}
              </div>
              <div>
                <h3 className="text-sm font-bold text-gray-900">Cash on Delivery</h3>
                <p className="mt-0.5 text-xs text-gray-500">
                  Pay cash at the time of delivery
                </p>
              </div>
            </div>

            <CodLogo />
          </div>
        </div>

        {/* Option 5: Wallet */}
        <div
          onClick={() => onSelectPaymentMethod("WALLET")}
          className={`cursor-pointer rounded-xl border p-4 transition-all ${
            paymentMethod === "WALLET"
              ? "border-2 border-[#046a38] bg-emerald-50/20 shadow-sm"
              : "border-gray-200 bg-white hover:border-gray-300"
          }`}
        >
          <div className="flex items-center justify-between gap-3">
            <div className="flex items-start gap-3">
              <div className={`mt-0.5 flex h-4 w-4 shrink-0 items-center justify-center rounded-full border ${
                paymentMethod === "WALLET" ? "border-[#046a38]" : "border-gray-400"
              }`}>
                {paymentMethod === "WALLET" && <div className="h-2 w-2 rounded-full bg-[#046a38]" />}
              </div>
              <div>
                <h3 className="text-sm font-bold text-gray-900">Wallet</h3>
                <p className="mt-0.5 text-xs text-gray-500">
                  Available balance: ₹{Number(walletBalance || 0).toFixed(2)}
                </p>
              </div>
            </div>
            <FaWallet className="h-5 w-5 shrink-0 text-[#046a38]" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutPaymentMethods;
